import { defineMessages } from "react-intl";

const messages = defineMessages({
  addRecipientButtonLabel: {
    id: "email.creation.composeModal.addRecipientButtonLabel",
    defaultMessage: "+ Add Email",
    description: "Add recipient button label",
  },
  closeConfirmationNo: {
    id: "email.creation.composeModal.closeConfirmationNo",
    defaultMessage: "No",
    description: "Close confirmation no",
  },
  closeConfirmationTitle: {
    id: "email.creation.composeModal.closeConfirmationTitle",
    defaultMessage: "Close without sending? Your email will be saved as a draft.",
    description: "Close confirmation title",
  },
  closeConfirmationYes: {
    id: "email.creation.composeModal.closeConfirmationYes",
    defaultMessage: "Yes",
    description: "Close confirmation yes",
  },
  more: {
    id: "email.creation.composeModal.recipients.moreText",
    defaultMessage: "More",
    description: "More text for recipients",
  },
  multipleRecipientsInfo: {
    id: "email.creation.composeModal.recipients.multipleRecipientsInfo",
    defaultMessage:
      "Each recipient will receive an individual copy of this email and won't see the other recipients.",
    description: "Tooltip shown on To label when multiple recipients are selected",
  },
  next: {
    id: "email.creation.composeModal.next",
    defaultMessage: "Next",
    description: "Next button in email creation modal",
  },
  nextConfirmationNo: {
    id: "email.creation.composeModal.nextConfirmationNo",
    defaultMessage: "Cancel",
    description: "Next confirmation no",
  },
  nextConfirmationTitle: {
    id: "email.creation.composeModal.nextConfirmationTitle",
    defaultMessage: "Changes to template were not saved. Send anyways?",
    description: "Next confirmation title",
  },
  nextConfirmationYes: {
    id: "email.creation.composeModal.nextConfirmationYes",
    defaultMessage: "Send anyways",
    description: "Next confirmation yes",
  },
  primaryRecipientTooltip: {
    id: "email.creation.composeModal.recipients.primaryTooltip",
    defaultMessage: "Primary contact for the logged activity",
    description: "Tooltip on the star of the primary recipient",
  },
  recipientTypeSelectorDisabledBecauseOfAppliedDynamicVariableTooltip: {
    id: "email.creation.composeModal.recipientTypeSelector.disabledBecauseOfAppliedDynamicVariableTooltip",
    defaultMessage:
      "This is disabled because you have inserted this type of variable in your email.",
    description: "Recipient type selector disabled because of added dynamic variable tooltip",
  },
  recipientTypeSelectorDisabledBecauseOfAppliedTemplateTooltip: {
    id: "email.creation.composeModal.recipientTypeSelector.recipientTypeSelectorDisabledBecauseOfAppliedTemplateTooltip",
    defaultMessage: "This is disabled because you have applied this type of template.",
    description: "Recipient type selector disabled because of applied entity variable tooltip",
  },
  savedLabel: {
    id: "email.creation.composeModal.savedLabel",
    defaultMessage: "Saved {relativeTime}",
    description: "Saved label",
  },
  setPrimaryRecipientTooltip: {
    id: "email.creation.composeModal.recipients.setPrimaryTooltip",
    defaultMessage: "Set as primary contact",
    description: "Tooltip on the star used to designate a recipient as primary",
  },
  subTitle: {
    id: "email.creation.composeModal.subTitle",
    defaultMessage: "{sent}/{total} sends left today",
    description: "Sub Title of email creation modal",
  },
  title: {
    id: "email.creation.composeModal.title",
    defaultMessage: "Email",
    description: "Title of email creation modal",
  },
  to: {
    id: "email.creation.composeModal.recipients.to",
    defaultMessage: "To",
    description: "To text for recipients",
  },
});

export default messages;
